/* Shop page: featured band colour picker (shares the site-wide colour via Dozzee.setColour). */
(function () {
  function init(sec) {
    if (sec._dzShop) return; sec._dzShop = 1;
    var D = window.Dozzee || {}, cols = D.colours || [];
    var box = sec.querySelector('[data-sh-swatches]');
    if (!box || !cols.length) return;
    var tint = sec.querySelector('[data-sh-tint]'), img = sec.querySelector('[data-sh-img]'),
        mood = sec.querySelector('[data-sh-mood]'), no = sec.querySelector('[data-sh-no]'),
        cta = sec.querySelector('[data-sh-cta]'), band = sec.querySelector('[data-sh-band]');
    var sell = sec.getAttribute('data-sell') === 'true', base = sec.getAttribute('data-band-url') || '';

    cols.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sh-swatch'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.name); b.title = c.name; b.style.setProperty('--c', c.hex);
      b.addEventListener('click', function () { D.setColour(c.key, 'shop'); });
      b.dataset.key = c.key; box.appendChild(b);
    });

    function apply(c, instant) {
      Array.prototype.forEach.call(box.children, function (b) { b.setAttribute('aria-checked', b.dataset.key === c.key ? 'true' : 'false'); });
      sec.querySelectorAll('[data-sh-name]').forEach(function (el) { el.textContent = c.name; });
      if (tint) tint.style.backgroundColor = c.tint;
      if (band) band.style.setProperty('--deep', c.deep);
      if (mood) mood.textContent = c.mood;
      if (no) no.textContent = 'No. ' + c.no;
      if (cta) {
        var u = base;
        if (sell && c.variantId) u += (u.indexOf('?') < 0 ? '?' : '&') + 'variant=' + c.variantId;
        cta.href = sell ? u : u + '#notify';
      }
      if (img && img.getAttribute('src') !== c.band) {
        if (instant || D.reduce) { img.src = c.band; return; }
        img.classList.add('is-swapping');
        setTimeout(function () { img.src = c.band; img.classList.remove('is-swapping'); }, 220);
      }
    }
    apply(D.getColour(), true);
    document.addEventListener('dozzee:colour', function (e) { apply(e.detail.colour); });
  }
  /* Gift product page: thumbnails + Add to bag via fetch (falls back to normal submit). */
  function initSimple(sec) {
    if (sec._dzSg) return; sec._dzSg = 1;
    var slides = sec.querySelectorAll('[data-sg-slide]'), thumbs = sec.querySelectorAll('[data-sg-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-sg-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-sg-slide') === i); });
        thumbs.forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
      });
    });
    var D = window.Dozzee || {}, band = sec.querySelector('[data-sg-band]');
    if (band && D.getColour) { var c = D.getColour(); if (c) band.src = c.band; }
    var form = sec.querySelector('[data-sg-form]');
    if (form && D.addToCart) form.addEventListener('submit', function (e) {
      var id = form.querySelector('[name="id"]'), btn = form.querySelector('[type="submit"]'), lab = btn && btn.querySelector('span:last-child');
      if (!id) return;
      e.preventDefault(); if (btn) btn.disabled = true;
      var old = lab ? lab.textContent : '';
      D.addToCart(+id.value, 1).then(function () {
        if (lab) lab.textContent = btn.getAttribute('data-added');
        setTimeout(function () { if (lab) lab.textContent = old; btn.disabled = false; }, 2200);
      }).catch(function () { form.submit(); });
    });
  }
  function boot(root) {
    (root || document).querySelectorAll('[data-section-type="shop-hero"]').forEach(init);
    (root || document).querySelectorAll('[data-section-type="product-simple"]').forEach(initSimple);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
